/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1CoachSettingsPayload
 */
export interface V1CoachSettingsPayload {
    /**
     *
     */
    enabled: boolean
    /**
     *
     */
    autoAccept: boolean
    /**
     *
     */
    languages?: Array<string>
    /**
     *
     */
    price?: number
    /**
     *
     */
    aiPersona?: string
    /**
     *
     */
    aiWorkoutInstructions?: string
}

/**
 * Check if a given object implements the V1CoachSettingsPayload interface.
 */
export function instanceOfV1CoachSettingsPayload(
    value: object
): value is V1CoachSettingsPayload {
    if (!('enabled' in value) || value['enabled'] === undefined) return false
    if (!('autoAccept' in value) || value['autoAccept'] === undefined)
        return false
    return true
}

export function V1CoachSettingsPayloadFromJSON(
    json: any
): V1CoachSettingsPayload {
    return V1CoachSettingsPayloadFromJSONTyped(json, false)
}

export function V1CoachSettingsPayloadFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachSettingsPayload {
    if (json == null) {
        return json
    }
    return {
        enabled: json['enabled'],
        autoAccept: json['autoAccept'],
        languages: json['languages'] == null ? undefined : json['languages'],
        price: json['price'] == null ? undefined : json['price'],
        aiPersona: json['aiPersona'] == null ? undefined : json['aiPersona'],
        aiWorkoutInstructions:
            json['aiWorkoutInstructions'] == null
                ? undefined
                : json['aiWorkoutInstructions']
    }
}

export function V1CoachSettingsPayloadToJSON(
    json: any
): V1CoachSettingsPayload {
    return V1CoachSettingsPayloadToJSONTyped(json, false)
}

export function V1CoachSettingsPayloadToJSONTyped(
    value?: V1CoachSettingsPayload | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        enabled: value['enabled'],
        autoAccept: value['autoAccept'],
        languages: value['languages'],
        price: value['price'],
        aiPersona: value['aiPersona'],
        aiWorkoutInstructions: value['aiWorkoutInstructions']
    }
}
